import script from "./SegmentCostCounter.vue?vue&type=script&setup=true&lang=ts"
export * from "./SegmentCostCounter.vue?vue&type=script&setup=true&lang=ts"

import "./SegmentCostCounter.vue?vue&type=style&index=0&id=73cf9cd5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73cf9cd5"]])

export default __exports__